import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { SamplingPoint } from "src/app/domain/sampling-point";
import { Injectable } from "@angular/core";
import { SamplingPointEntity } from "../sampling-point.entity";

@Injectable({
    providedIn: 'root',
})
export class SamplingPointRepository {
    async getSamplingPointById(samplingPointId: number) {
        return await db.samplingPoints.where('Id').equals(samplingPointId).first(async spe => {
            const samplingPoint = mapper.map(spe, SamplingPointEntity, SamplingPoint);
            return samplingPoint;
        });
    }

    async attachSamplingPoint(sp: SamplingPoint, pId: number) {
        let samplingPointId: number;
        const spe = mapper.map(sp, SamplingPoint, SamplingPointEntity);

        samplingPointId = await db.samplingPoints.add(spe);
        await db.prelevements.update(pId, {
            SamplingPointId: samplingPointId
        });
        return samplingPointId;

    }
}